import Axios from 'axios';
import { useContext, useEffect, useState, useRef } from 'react';
import { Form } from 'react-bootstrap';

import DashboardContext from '../../Context';
import Select from 'react-select';
import PropTypes from 'prop-types';

/**
 *  این کامپوننت برای نمایش  دراپ دان های چندتای است
 *
 */
export default function InputControlMulti({
  url,
  name,
  defaultValue,
  handelValue,
  label,
  data,
  disabled,
  isClear,
  dependency,
  noNested = false,
  hasDefValueOnPurpose = false,
}) {
  const { authentication, urldashboard, handelloding, handelerrors } =
    useContext(DashboardContext);

  const [arrystate, setArrystate] = useState([]);

  const selectInputRef = useRef();

  const dataFeching = async () => {
    try {
      const res = await Axios.get(`${urldashboard}${url}`, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json; charset=utf-8 ',
        },
      });
      const data = await res.data;
      if (!noNested) setArrystate(data?.data); else setArrystate(data);
      handelloding(false);
    } catch (error) {
      handelerrors(error);
      handelloding(false);
    }
  };

  const handeloncheng = (event) => {
    
    let datavalue = [];
    if (event) {
      event.map((item) => datavalue.push(item.value));
    } else {
      datavalue = [];
    }

    handelValue(name, datavalue);
  };

  useEffect(() => {
    if (!dependency) data ? setArrystate(data) : dataFeching();
    if (defaultValue?.length > 0 && hasDefValueOnPurpose) handelValue(name, defaultValue);
    return () => {};
  }, []);

  useEffect(() => {
    if (dependency && Object?.values(dependency)?.some((val) => val)) {
      dataFeching();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dependency?.startDate,
     dependency?.endDate,
      dependency?.companyId,
      dependency?.addressId,
      dependency?.orderStartHour,
      dependency?.orderEndHour,
    ]);

  useEffect(() => {
    if (isClear) {
      selectInputRef.current.select.clearValue();
    }
    return () => {};
  }, [isClear, disabled]);

  return (
    <Form.Group>
      {label ? <Form.Label>{label}</Form.Label> : null}
      {defaultValue !== undefined ? (
        arrystate?.length > 0 ? (
          <>
            <Select
              className='basic-multi-select'
              classNamePrefix='select'
              styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
              defaultValue={arrystate?.filter((item) =>
                defaultValue?.includes(item.value)
              )}
              onChange={handeloncheng}
              isLoading={arrystate?.length > 0 ? false : true}
              isRtl
              isMulti
              isDisabled={disabled}
              name={name}
              closeMenuOnSelect={false}
              ref={selectInputRef}
              options={[
                {
                  label: label,
                  options: arrystate,
                },
              ]}
            />
          </>
        ) : null
      ) : (
        <Select
          className='basic-multi-select'
          classNamePrefix='select'
          styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
          onChange={handeloncheng}
          isLoading={arrystate?.length > 0 ? false : true}
          isRtl
          isMulti
          closeMenuOnSelect={false}
          isDisabled={disabled}
          ref={selectInputRef}
          name={name}
          options={[
            {
              label: label,
              options: arrystate,
            },
          ]}
        />
      )}
    </Form.Group>
  );
}
InputControlMulti.propTypes = {
  /**لیبل اینپوت است */
  label: PropTypes.string,
  /**برای ارسال مقدار اولیه برای اینپوت است */
  defaultValue: PropTypes.array,
  /** مقدار هلدر اینپوت است */
  Placeholder: PropTypes.string,
  /** نام اینپوت است */
  name: PropTypes.string,
  /** ارسال مقدار اینپوت به بالا است */
  handelValue: PropTypes.func,
  /**آدرس که برای دریافت داده استفاده می شود */
  url: PropTypes.string,
  /**برای این که کامپوننت داده هایش پاک شود یا خیر */
  isClear: PropTypes.bool,
  /** آیا فعال باشد برای کار یا خیر*/
  disabled: PropTypes.bool,
  /**اگر این باشد فچ انجام نوی شود */
  data: PropTypes.array,
};
